import { useEffect } from 'react';
import { X } from 'lucide-react';

// Anteprima di un PDF già scaricato come blob (gli endpoint sono autenticati, l'iframe non
// potrebbe chiamarli da solo).
export default function PdfPreviewModal({ url, title, onClose }: { url: string; title: string; onClose: () => void }) {
  useEffect(() => () => URL.revokeObjectURL(url), [url]);
  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={title}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl h-[90vh] flex flex-col">
        <div className="flex items-center justify-between px-4 py-2 border-b border-gray-100">
          <h3 className="font-medium text-gray-900 text-sm">{title}</h3>
          <button onClick={onClose} aria-label="Close preview" className="text-gray-500 hover:text-gray-800"><X size={16} /></button>
        </div>
        <iframe title={title} src={url} className="flex-1 w-full" />
      </div>
    </div>
  );
}
